import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import * as React from "react";
import React__default, { useEffect, useMemo, cloneElement, useLayoutEffect, useRef, useState, forwardRef, Fragment as Fragment$1, isValidElement, createElement, createContext, useContext, useReducer, createRef, useCallback } from "react";
import { create } from "zustand";
import Link from "next/link";
import { createPortal } from "react-dom";
const main = "";
function ArrowTopRightOnSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */ React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */ React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
  }));
}
const ForwardRef$2 = React.forwardRef(ArrowTopRightOnSquareIcon);
const ArrowTopRightOnSquareIcon$1 = ForwardRef$2;
function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */ React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */ React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.5 8.25-7.5 7.5-7.5-7.5"
  }));
}
const ForwardRef$1 = React.forwardRef(ChevronDownIcon);
const ChevronDownIcon$1 = ForwardRef$1;
function ChevronLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */ React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */ React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 19.5 8.25 12l7.5-7.5"
  }));
}
const ForwardRef = React.forwardRef(ChevronLeftIcon);
const ChevronLeftIcon$1 = ForwardRef;
function twJoin() {
  var index = 0;
  var argument;
  var resolvedValue;
  var string = "";
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
function toValue(mix) {
  if (typeof mix === "string") {
    return mix;
  }
  var resolvedValue;
  var string = "";
  for (var k2 = 0; k2 < mix.length; k2++) {
    if (mix[k2]) {
      if (resolvedValue = toValue(mix[k2])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
var CLASS_PART_SEPARATOR = "-";
function createClassUtils(config) {
  var classMap = createClassMap(config);
  var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
  function getClassGroupId(className) {
    var classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  }
  function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
    var conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
    }
    return conflicts;
  }
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
}
function getGroupRecursive(classParts, classPartObject) {
  var _a;
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  var currentClassPart = classParts[0];
  var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  var classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  var classRest = classParts.join(CLASS_PART_SEPARATOR);
  return (_a = classPartObject.validators.find(function(_ref) {
    var validator = _ref.validator;
    return validator(classRest);
  })) == null ? void 0 : _a.classGroupId;
}
var arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(className) {
  if (arbitraryPropertyRegex.test(className)) {
    var arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    var property = arbitraryPropertyClassName == null ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property) {
      return "arbitrary.." + property;
    }
  }
}
function createClassMap(config) {
  var theme = config.theme, prefix = config.prefix;
  var classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  var prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(function(_ref2) {
    var classGroupId = _ref2[0], classGroup = _ref2[1];
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
}
function processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
  classGroup.forEach(function(classDefinition) {
    if (typeof classDefinition === "string") {
      var classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(function(_ref3) {
      var key = _ref3[0], classGroup2 = _ref3[1];
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
}
function getPart(classPartObject, path) {
  var currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach(function(pathPart) {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
}
function isThemeGetter(func) {
  return func.isThemeGetter;
}
function getPrefixedClassGroupEntries(classGroupEntries, prefix) {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(function(_ref4) {
    var classGroupId = _ref4[0], classGroup = _ref4[1];
    var prefixedClassGroup = classGroup.map(function(classDefinition) {
      if (typeof classDefinition === "string") {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === "object") {
        return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
          var key = _ref5[0], value = _ref5[1];
          return [prefix + key, value];
        }));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
}
function createLruCache(maxCacheSize) {
  if (maxCacheSize < 1) {
    return {
      get: function get() {
        return void 0;
      },
      set: function set() {
      }
    };
  }
  var cacheSize = 0;
  var cache = /* @__PURE__ */ new Map();
  var previousCache = /* @__PURE__ */ new Map();
  function update(key, value) {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ new Map();
    }
  }
  return {
    get: function get(key) {
      var value = cache.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set: function set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
}
var IMPORTANT_MODIFIER = "!";
function createSplitModifiers(config) {
  var separator = config.separator || ":";
  var isSeparatorSingleCharacter = separator.length === 1;
  var firstSeparatorCharacter = separator[0];
  var separatorLength = separator.length;
  return function splitModifiers(className) {
    var modifiers = [];
    var bracketDepth = 0;
    var modifierStart = 0;
    var postfixModifierPosition;
    for (var index = 0; index < className.length; index++) {
      var currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      }
    }
    var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    var hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
}
function sortModifiers(modifiers) {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  var sortedModifiers = [];
  var unsortedModifiers = [];
  modifiers.forEach(function(modifier) {
    var isArbitraryVariant = modifier[0] === "[";
    if (isArbitraryVariant) {
      sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([modifier]));
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
  return sortedModifiers;
}
function createConfigUtils(config) {
  return {
    cache: createLruCache(config.cacheSize),
    splitModifiers: createSplitModifiers(config),
    ...createClassUtils(config)
  };
}
var SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(classList, configUtils) {
  var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
  var classGroupsInConflict = /* @__PURE__ */ new Set();
  return classList.trim().split(SPLIT_CLASSES_REGEX).map(function(originalClassName) {
    var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
    var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    if (!classGroupId) {
      if (!maybePostfixModifierPosition) {
        return {
          isTailwindClass: false,
          originalClassName
        };
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        return {
          isTailwindClass: false,
          originalClassName
        };
      }
      hasPostfixModifier = false;
    }
    var variantModifier = sortModifiers(modifiers).join(":");
    var modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    return {
      isTailwindClass: true,
      modifierId,
      classGroupId,
      originalClassName,
      hasPostfixModifier
    };
  }).reverse().filter(function(parsed) {
    if (!parsed.isTailwindClass) {
      return true;
    }
    var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
    var classId = modifierId + classGroupId;
    if (classGroupsInConflict.has(classId)) {
      return false;
    }
    classGroupsInConflict.add(classId);
    getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
      return classGroupsInConflict.add(modifierId + group);
    });
    return true;
  }).reverse().map(function(parsed) {
    return parsed.originalClassName;
  }).join(" ");
}
function createTailwindMerge() {
  for (var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++) {
    createConfig[_key] = arguments[_key];
  }
  var configUtils;
  var cacheGet;
  var cacheSet;
  var functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
    var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
      return createConfigCurrent(previousConfig);
    }, firstCreateConfig());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    var cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    var result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
function fromTheme(key) {
  var themeGetter = function themeGetter2(theme) {
    return theme[key] || [];
  };
  themeGetter.isThemeGetter = true;
  return themeGetter;
}
var arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var fractionRegex = /^\d+\/\d+$/;
var stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]);
var tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
var shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function isLength(value) {
  return isNumber(value) || stringLengths.has(value) || fractionRegex.test(value) || isArbitraryLength(value);
}
function isArbitraryLength(value) {
  return getIsArbitraryValue(value, "length", isLengthOnly);
}
function isArbitrarySize(value) {
  return getIsArbitraryValue(value, "size", isNever);
}
function isArbitraryPosition(value) {
  return getIsArbitraryValue(value, "position", isNever);
}
function isArbitraryUrl(value) {
  return getIsArbitraryValue(value, "url", isUrl);
}
function isArbitraryNumber(value) {
  return getIsArbitraryValue(value, "number", isNumber);
}
function isNumber(value) {
  return !Number.isNaN(Number(value));
}
function isPercent(value) {
  return value.endsWith("%") && isNumber(value.slice(0, -1));
}
function isInteger(value) {
  return isIntegerOnly(value) || getIsArbitraryValue(value, "number", isIntegerOnly);
}
function isArbitraryValue(value) {
  return arbitraryValueRegex.test(value);
}
function isAny() {
  return true;
}
function isTshirtSize(value) {
  return tshirtUnitRegex.test(value);
}
function isArbitraryShadow(value) {
  return getIsArbitraryValue(value, "", isShadow);
}
function getIsArbitraryValue(value, label, testValue) {
  var result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return result[1] === label;
    }
    return testValue(result[2]);
  }
  return false;
}
function isLengthOnly(value) {
  return lengthUnitRegex.test(value);
}
function isNever() {
  return false;
}
function isUrl(value) {
  return value.startsWith("url(");
}
function isIntegerOnly(value) {
  return Number.isInteger(Number(value));
}
function isShadow(value) {
  return shadowRegex.test(value);
}
function getDefaultConfig() {
  var colors = fromTheme("colors");
  var spacing = fromTheme("spacing");
  var blur = fromTheme("blur");
  var brightness = fromTheme("brightness");
  var borderColor = fromTheme("borderColor");
  var borderRadius = fromTheme("borderRadius");
  var borderSpacing = fromTheme("borderSpacing");
  var borderWidth = fromTheme("borderWidth");
  var contrast = fromTheme("contrast");
  var grayscale = fromTheme("grayscale");
  var hueRotate = fromTheme("hueRotate");
  var invert = fromTheme("invert");
  var gap = fromTheme("gap");
  var gradientColorStops = fromTheme("gradientColorStops");
  var gradientColorStopPositions = fromTheme("gradientColorStopPositions");
  var inset = fromTheme("inset");
  var margin = fromTheme("margin");
  var opacity = fromTheme("opacity");
  var padding = fromTheme("padding");
  var saturate = fromTheme("saturate");
  var scale = fromTheme("scale");
  var sepia = fromTheme("sepia");
  var skew = fromTheme("skew");
  var space = fromTheme("space");
  var translate = fromTheme("translate");
  var getOverscroll = function getOverscroll2() {
    return ["auto", "contain", "none"];
  };
  var getOverflow = function getOverflow2() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  };
  var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary2() {
    return ["auto", isArbitraryValue, spacing];
  };
  var getSpacingWithArbitrary = function getSpacingWithArbitrary2() {
    return [isArbitraryValue, spacing];
  };
  var getLengthWithEmpty = function getLengthWithEmpty2() {
    return ["", isLength];
  };
  var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary2() {
    return ["auto", isNumber, isArbitraryValue];
  };
  var getPositions = function getPositions2() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  };
  var getLineStyles = function getLineStyles2() {
    return ["solid", "dashed", "dotted", "double", "none"];
  };
  var getBlendModes = function getBlendModes2() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  };
  var getAlign = function getAlign2() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  };
  var getZeroAndEmpty = function getZeroAndEmpty2() {
    return ["", "0", isArbitraryValue];
  };
  var getBreaks = function getBreaks2() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  };
  var getNumber = function getNumber2() {
    return [isNumber, isArbitraryNumber];
  };
  var getNumberAndArbitrary = function getNumberAndArbitrary2() {
    return [isNumber, isArbitraryValue];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [isAny],
      spacing: [isLength],
      blur: ["none", "", isTshirtSize, isArbitraryValue],
      brightness: getNumber(),
      borderColor: [colors],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmpty(),
      contrast: getNumber(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumber(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumber(),
      scale: getNumber(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      "float": [{
        "float": ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(getPositions(), [isArbitraryValue])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(getAlign())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(getAlign(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(getAlign(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", isArbitraryValue, isLength]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize, isArbitraryValue]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", isArbitraryValue, isLength]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [isArbitraryValue, spacing, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isArbitraryValue, isLength]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(getLineStyles(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isArbitraryValue, isLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      "break": [{
        "break": ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(getPositions(), [isArbitraryPosition])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryUrl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(getLineStyles(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(getLineStyles())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isArbitraryValue, isLength]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: getLengthWithEmpty()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": getBlendModes()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
const initialState = {
  sidebarOpened: true,
  setSidebarOpened: (value) => {
  },
  activeMenu: "Home",
  setActiveMenu: (value) => {
  },
  onMenuItemClick: void 0,
  setOnMenuItemClick: (value) => {
  },
  openMenuItem: "",
  setOpenMenuItem: (value) => {
  },
  logger: void 0,
  setLogger: (logger) => {
  },
  isPortalHost: false,
  setIsPortalHost: (isPortalHost) => {
  },
  linkPostfix: "",
  setLinkPostfix: (value) => {
  }
};
const initializeState = (set) => ({
  ...initialState,
  setSidebarOpened: (value) => set(() => ({ sidebarOpened: value })),
  setActiveMenu: (value) => set(() => ({ activeMenu: value })),
  setOnMenuItemClick: (value) => set(() => ({ onMenuItemClick: value })),
  setOpenMenuItem: (value) => set(() => ({ openMenuItem: value })),
  setLogger: (logger) => set(() => ({ logger })),
  setIsPortalHost: (isPortalHost) => set(() => ({ isPortalHost })),
  setLinkPostfix: (linkPostfix) => set(() => ({ linkPostfix }))
});
const useSidebarStore = create((set) => ({
  ...initializeState(set)
}));
const useSidebarHandlers = ({
  logger,
  sidebarOpened,
  setSidebarOpened,
  onSidebarOpened,
  onSidebarClosed,
  isPortalHost = false,
  activeMenu,
  setActiveMenu,
  linkPostfix
}) => {
  const {
    setLogger,
    setSidebarOpened: setStoreSidebarOpened,
    sidebarOpened: storeSidebarOpened,
    setIsPortalHost,
    activeMenu: storeActiveMenu,
    setActiveMenu: storeSetActiveMenu,
    setLinkPostfix
  } = useSidebarStore();
  useEffect(() => {
    if (logger) {
      setLogger(logger);
    }
  }, [logger, setLogger]);
  useEffect(() => {
    setIsPortalHost(isPortalHost);
  }, [isPortalHost, setIsPortalHost]);
  useEffect(() => {
    if (linkPostfix !== void 0)
      setLinkPostfix(linkPostfix);
  }, [linkPostfix, setLinkPostfix]);
  useEffect(() => {
    if (activeMenu !== void 0) {
      storeSetActiveMenu(activeMenu);
    }
  }, [activeMenu, storeSetActiveMenu]);
  useEffect(() => {
    if (storeActiveMenu !== activeMenu && setActiveMenu) {
      setActiveMenu(storeActiveMenu);
    }
  }, [storeActiveMenu, activeMenu, setActiveMenu]);
  useEffect(() => {
    if (sidebarOpened !== void 0) {
      setStoreSidebarOpened(sidebarOpened);
    }
    if (sidebarOpened || storeSidebarOpened) {
      onSidebarOpened == null ? void 0 : onSidebarOpened();
    } else {
      onSidebarClosed == null ? void 0 : onSidebarClosed();
    }
  }, [sidebarOpened, onSidebarOpened, onSidebarClosed, setStoreSidebarOpened]);
  useEffect(() => {
    if (storeSidebarOpened !== sidebarOpened && setSidebarOpened) {
      setSidebarOpened(storeSidebarOpened);
    }
  }, [storeSidebarOpened, sidebarOpened, setSidebarOpened]);
};
function ExternalLink({
  children,
  className,
  onClick = () => {
  },
  ...props
}) {
  function onClickHandler(event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    onClick(event);
  }
  return /* @__PURE__ */ jsx(
    "a",
    {
      target: "_blank",
      rel: "noopener noreferrer",
      className: twMerge("hover:no-underline", className),
      onClick: onClickHandler,
      ...props,
      children
    }
  );
}
const SidebarFooter = ({
  className,
  isMobile
}) => {
  return /* @__PURE__ */ jsx("div", { className: "w-full px-[6px] pb-[6px]", children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: twMerge(
        "flex flex-col gap-[12px] mx-auto pb-[20px] px-[12px] w-[224px]",
        isMobile && "w-full",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs("div", { className: "border-b border-white/30 py-[16px] text-white", children: [
          "The Most Decentralized ",
          /* @__PURE__ */ jsx("br", {}),
          " L2 Technology"
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-[8px] text-[#999999]", children: [
            /* @__PURE__ */ jsx(
              ExternalLink,
              {
                className: "cursor-pointer text-xs text-[#999999]",
                href: "https://status.arbitrum.io/",
                children: "Status"
              }
            ),
            "•",
            /* @__PURE__ */ jsx(
              ExternalLink,
              {
                className: "cursor-pointer text-[12px] text-[#999999]",
                href: "https://arbitrumfoundation.notion.site/arbitrumfoundation/Arbitrum-Brand-Kit-48751dc5e03240a5872496283f088f79",
                children: "Media Kit"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-[8px] text-[#999999]", children: [
            /* @__PURE__ */ jsx(
              ExternalLink,
              {
                className: "cursor-pointer text-xs text-[#999999]",
                href: "https://arbitrum.io/tos",
                children: "ToS"
              }
            ),
            "•",
            /* @__PURE__ */ jsx(
              ExternalLink,
              {
                className: "cursor-pointer text-[12px] text-[#999999]",
                href: "https://arbitrum.io/privacy",
                children: "Privacy Policy"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "text-[12px] text-[#999999]", children: [
          "Built with love by",
          " ",
          /* @__PURE__ */ jsx(ExternalLink, { className: "hover:underline", href: "https://offchainlabs.com/", children: "Offchain Labs" }),
          ", builders of",
          " ",
          /* @__PURE__ */ jsx(ExternalLink, { className: "hover:underline", href: "https://arbitrum.io/", children: "Arbitrum technology." })
        ] })
      ]
    }
  ) });
};
const ArbitrumLogoExpanded = "data:image/svg+xml;base64,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";
const ArbitrumLogoCollapsed = "data:image/svg+xml;base64,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";
const SidebarHeader = () => {
  const { sidebarOpened } = useSidebarStore();
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: twMerge(
        "mx-auto pb-[64px]",
        sidebarOpened ? "w-[155px] h-[35px]" : "w-[35px] h-[35px]"
      ),
      children: /* @__PURE__ */ jsxs("a", { href: "https://arbitrum.io", children: [
        /* @__PURE__ */ jsx(
          "img",
          {
            src: ArbitrumLogoExpanded,
            className: twMerge("hidden", sidebarOpened && "block"),
            alt: "Arbitrum logo",
            width: "155",
            height: "35"
          }
        ),
        /* @__PURE__ */ jsx(
          "img",
          {
            src: ArbitrumLogoCollapsed,
            className: twMerge("hidden", !sidebarOpened && "block"),
            alt: "Arbitrum logo",
            width: "35",
            height: "35"
          }
        )
      ] })
    }
  );
};
const IconBridge = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy45MTQzIDEwLjc0MDRDMTUuMzI2OCA5LjQwNDQ2IDEwLjI3NDYgNi43OTM2IDcuNDM0OTIgNS4zMjYyNEM2LjkyMjExIDUuMDYwOTIgNi4zMDA1MyA1LjEzNDA1IDUuODYyNzIgNS41MDkwNUM1LjQyMzk4IDUuODg0MDUgNS4yNTgwNCA2LjQ4NTkyIDUuNDM5OTEgNy4wMzM0M0w3LjA1ODA0IDExLjg4MDJDNy4wODk5MiAxMS45Nzc3IDcuMDg5OTIgMTIuMDgyNyA3LjA1NzExIDEyLjE4MDJMNS40NDkzIDE2Ljk1NzdDNS4yNjQ2MSAxNy41MDQyIDUuNDMwNTUgMTguMTA4OSA1Ljg2ODM2IDE4LjQ4NDlDNi4zMDcxMSAxOC44NjA4IDYuOTI5NjIgMTguOTMzIDcuNDQyNDMgMTguNjY4NkwxNy45MTQzIDEzLjI1ODNDMTguMzg1IDEzLjAxNDYgMTguNjgwMyAxMi41Mjg5IDE4LjY4MDMgMTEuOTk5MkMxOC42ODAzIDExLjQ2OTYgMTguMzg1IDEwLjk4MzkgMTcuOTE0MyAxMC43NDAyTDE3LjkxNDMgMTAuNzQwNFpNNy45NTYxOSAxMi40NzE5QzcuOTU1MjYgMTIuNDc0OCA3Ljk1MzM4IDEyLjQ3ODUgNy45NTI0NCAxMi40ODIzTDYuMzQ0NjQgMTcuMjU4N0M2LjI4Mjc2IDE3LjQ0MTYgNi4zMzgwNyAxNy42NDIyIDYuNDg0MzIgMTcuNzY3OEM2LjYzMDU4IDE3Ljg5MzQgNi44Mzc3NyAxNy45MTc4IDcuMDA4MzkgMTcuODI4N0wxNy40ODAzIDEyLjQxODRDMTcuNjM2OSAxMi4zMzc4IDE3LjczNjIgMTIuMTc1NiAxNy43MzYyIDExLjk5OTRDMTcuNzM2MiAxMS44MjMxIDE3LjYzNjkgMTEuNjYwOSAxNy40ODAzIDExLjU4MDNMNy4wMDA5NSA2LjE2NTQyQzYuODMwMzIgNi4wNzcyOSA2LjYyMzE0IDYuMTAwNzMgNi40NzY4OCA2LjIyNjM1QzYuMzMwNjMgNi4zNTEwNCA2LjI3NTMyIDYuNTUyNjEgNi4zMzYyNiA2LjczNDQ4TDcuOTM1NjQgMTEuNTI3SDEzLjQxNzJDMTMuNjc3OSAxMS41MjcgMTMuODg5OCAxMS43Mzg5IDEzLjg4OTggMTEuOTk5NkMxMy44ODk4IDEyLjI2MDIgMTMuNjc3OSAxMi40NzIxIDEzLjQxNzIgMTIuNDcyMUw3Ljk1NjE5IDEyLjQ3MTlaIiBmaWxsPSIjQ0NDQ0NDIi8+Cjwvc3ZnPgo=";
const IconCommunity = "data:image/svg+xml;base64,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";
const IconDevelopers = "data:image/svg+xml;base64,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";
const IconGetHelp = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjM4ODY3IDE0LjgzNDNDNS4zODg2NyAxNS4yMTAyIDUuNTM3NzMgMTUuNTcwMiA1LjgwMzA2IDE1LjgzNTZDNi4wNjkzMSAxNi4xMDE4IDYuNDI5MzEgMTYuMjUwOSA2LjgwNTI1IDE2LjI1MDlIMTMuMjc3OEwxNC42MzA2IDE3LjYzODRDMTQuODk4NyAxNy45MTQgMTUuMzA3NSAxNy45OTkzIDE1LjY2MjggMTcuODU0OUMxNi4wMTkxIDE3LjcwOTYgMTYuMjUxNiAxNy4zNjM3IDE2LjI1MTYgMTYuOTc5M1YxNi4yNTA5SDE3LjE5NjZDMTcuOTc5NCAxNi4yNTA5IDE4LjYxMzEgMTUuNjE3MSAxOC42MTMxIDE0LjgzNDNWNy43NDk1MkMxOC42MTMxIDYuOTY2NzEgMTcuOTc5NCA2LjMzMjAzIDE3LjE5NjYgNi4zMzIwM0g2LjgwNTI3QzYuMDIyNDYgNi4zMzIwMyA1LjM4ODcyIDYuOTY2NzEgNS4zODg3MiA3Ljc0OTUyTDUuMzg4NjcgMTQuODM0M1pNMTUuMzA3NCAxNi45NzkzQzE0LjY0MzcgMTYuMjk5NiAxMy44MTQ5IDE1LjQ0OTMgMTMuODE0OSAxNS40NDkzQzEzLjcyNTggMTUuMzU4NCAxMy42MDM5IDE1LjMwNjggMTMuNDc2NCAxNS4zMDY4SDYuODA1MTVDNi42ODA0NiAxNS4zMDY4IDYuNTU5NTQgMTUuMjU3MSA2LjQ3MTQxIDE1LjE2ODFDNi4zODIzNSAxNS4wNzk5IDYuMzMyNjYgMTQuOTU5IDYuMzMyNjYgMTQuODM0M1Y3Ljc0OTUyQzYuMzMyNjYgNy40ODg5IDYuNTQ0NTMgNy4yNzcwMSA2LjgwNTE3IDcuMjc3MDFIMTcuMTk2NUMxNy40NTcxIDcuMjc3MDEgMTcuNjY5IDcuNDg4ODggMTcuNjY5IDcuNzQ5NTJWMTQuODM0M0MxNy42NjkgMTUuMDk0OSAxNy40NTcxIDE1LjMwNjggMTcuMTk2NSAxNS4zMDY4SDE1Ljc3OUMxNS41MTgzIDE1LjMwNjggMTUuMzA3NCAxNS41MTc4IDE1LjMwNzQgMTUuNzc4NEwxNS4zMDc0IDE2Ljk3OTNaIiBmaWxsPSIjQ0NDQ0NDIi8+Cjwvc3ZnPgo=";
const IconHome = "data:image/svg+xml;base64,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";
const IconChains = "data:image/svg+xml;base64,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";
const IconProjects = "data:image/svg+xml;base64,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";
const Div = (props) => /* @__PURE__ */ jsx("div", { ...props, children: props.children });
const MenuItem = ({
  external,
  expanded,
  children,
  href,
  title,
  iconSrc,
  Icon,
  className,
  isSubmenu,
  titleClassName,
  isActiveOverride,
  as,
  shouldAddLinkPostfix,
  isMobile,
  ...props
}) => {
  const {
    activeMenu,
    setActiveMenu,
    sidebarOpened,
    logger,
    isPortalHost,
    onMenuItemClick,
    linkPostfix
  } = useSidebarStore();
  const modifiedHref = useMemo(() => {
    if (!href)
      return href;
    let result = href;
    const portalUrl = "https://portal.arbitrum.io";
    if (isPortalHost && result.includes(portalUrl)) {
      result = result.replace(portalUrl, "");
    }
    if (shouldAddLinkPostfix && linkPostfix) {
      result += linkPostfix;
    }
    return result;
  }, [href, isPortalHost, shouldAddLinkPostfix, linkPostfix]);
  const isActive = activeMenu === title || isActiveOverride;
  function sendClickEventForMenuItem(menuItem) {
    logger == null ? void 0 : logger.capture("Sidebar Menu Item Click", {
      Item: menuItem
    });
  }
  const Component = useMemo(() => {
    if (as) {
      return as;
    }
    if (!modifiedHref) {
      return Div;
    }
    if (external) {
      return ExternalLink;
    }
    return Link;
  }, [modifiedHref, external]);
  const onClickHandler = (event) => {
    if (!external && !expanded) {
      setActiveMenu(title);
    }
    sendClickEventForMenuItem(title);
    onMenuItemClick == null ? void 0 : onMenuItemClick(title);
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    Component,
    {
      href: modifiedHref ?? "",
      className: twMerge(
        "group cursor-pointer px-[8px] hover:bg-[#2b2e30] rounded-md py-[8px] flex items-center text-[#cccccc] hover:text-white font-[400]",
        sidebarOpened || isMobile ? "gap-x-[16px]" : "mx-auto",
        isSubmenu && "py-[4px] pl-[20px] pr-0 text-[#999999]",
        isActive && "text-white bg-white/20",
        className
      ),
      onClick: onClickHandler,
      ...props,
      children: [
        Icon && Icon,
        iconSrc && /* @__PURE__ */ jsx("img", { src: iconSrc, alt: title, className: "h-[24px] w-[24px]" }),
        (sidebarOpened || isMobile) && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              className: twMerge(
                "grow origin-left text-left line-clamp-1",
                isSubmenu && "text-[14px] font-normal line-clamp-none",
                titleClassName
              ),
              children: title
            }
          ),
          children
        ] }),
        external && /* @__PURE__ */ jsx(
          ArrowTopRightOnSquareIcon$1,
          {
            className: twMerge(
              "h-[16px] w-[16px] opacity-70 group-hover:opacity-100 flex-shrink-0",
              !sidebarOpened && "hidden",
              isSubmenu && "mr-[8px]"
            )
          }
        )
      ]
    }
  ) });
};
const MenuItemExpandable = (props) => {
  var _a;
  const { openMenuItem, setOpenMenuItem, sidebarOpened, setSidebarOpened, logger, activeMenu } = useSidebarStore();
  const { title, children } = props;
  const isMenuItemOpen = openMenuItem.toLowerCase() === title.toLowerCase();
  function sendClickEventForGroup(groupTitle) {
    logger == null ? void 0 : logger.capture("Sidebar Menu Dropdown Click", {
      Group: groupTitle
    });
  }
  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      toggleMenu(event);
    }
  };
  const toggleMenu = (event) => {
    event.stopPropagation();
    setOpenMenuItem(isMenuItemOpen ? "" : title);
    setSidebarOpened(true);
    sendClickEventForGroup(title);
  };
  const MenuItemContent = () => {
    return React__default.Children.map(
      children,
      (child) => React__default.isValidElement(child) ? cloneElement(child, { ...child.props, isSubmenu: true }) : child
    );
  };
  const containsActiveItem = (_a = React__default.Children.toArray(children)) == null ? void 0 : _a.some(
    (child) => {
      var _a2;
      return React__default.isValidElement(child) && activeMenu === ((_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2.title);
    }
  );
  useEffect(() => {
    if (containsActiveItem) {
      setOpenMenuItem(title);
    }
  }, [activeMenu, containsActiveItem, setOpenMenuItem, title]);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx(
      MenuItem,
      {
        onClick: toggleMenu,
        onKeyDown,
        tabIndex: 0,
        expanded: true,
        isActiveOverride: containsActiveItem && !sidebarOpened,
        ...props,
        children: /* @__PURE__ */ jsx(
          ChevronDownIcon$1,
          {
            className: twMerge(
              "h-[16px] w-[16px] transition duration-200",
              isMenuItemOpen && "rotate-180",
              !sidebarOpened && "sm:hidden"
            ),
            width: 20,
            height: 20
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: twMerge(
          "flex max-h-0 shrink-0 grow-0 flex-col overflow-hidden text-[14px] transition-all duration-300 ml-[32px] gap-[2px] invisible",
          sidebarOpened && isMenuItemOpen && "max-h-[1000px] mt-[4px] visible"
        ),
        children: /* @__PURE__ */ jsx(MenuItemContent, {})
      }
    )
  ] });
};
const BRIDGE_LINK = "https://bridge.arbitrum.io/";
const GET_HELP_LINK = "https://support.arbitrum.io/";
const SidebarMenu = ({ children, className, isMobile }) => {
  const { sidebarOpened } = useSidebarStore();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: twMerge(
        "z-10 flex w-full flex-col gap-[15px] text-[#cccccc] sm:mt-[20px] h-full overflow-y-auto",
        (sidebarOpened || isMobile) && "px-[18px]",
        className
      ),
      children: [
        children,
        /* @__PURE__ */ jsx(
          MenuItem,
          {
            title: "Home",
            href: "https://portal.arbitrum.io/",
            iconSrc: IconHome,
            isMobile
          }
        ),
        /* @__PURE__ */ jsxs(MenuItemExpandable, { isMobile, title: "Projects", iconSrc: IconProjects, children: [
          /* @__PURE__ */ jsx(
            MenuItem,
            {
              title: "DeFi",
              href: "https://portal.arbitrum.io/projects/defi",
              shouldAddLinkPostfix: true,
              isMobile
            }
          ),
          /* @__PURE__ */ jsx(
            MenuItem,
            {
              title: "AI & DePIN",
              href: "https://portal.arbitrum.io/projects/ai-and-depin",
              shouldAddLinkPostfix: true,
              isMobile
            }
          ),
          /* @__PURE__ */ jsx(
            MenuItem,
            {
              title: "Gaming",
              href: "https://portal.arbitrum.io/projects/gaming",
              shouldAddLinkPostfix: true,
              isMobile
            }
          ),
          /* @__PURE__ */ jsx(
            MenuItem,
            {
              title: "NFTs",
              href: "https://portal.arbitrum.io/projects/nfts",
              shouldAddLinkPostfix: true,
              isMobile
            }
          ),
          /* @__PURE__ */ jsx(
            MenuItem,
            {
              title: "Bridges & On-ramps",
              href: "https://portal.arbitrum.io/projects/bridges-and-on-ramps",
              shouldAddLinkPostfix: true,
              isMobile
            }
          ),
          /* @__PURE__ */ jsx(
            MenuItem,
            {
              title: "Infra & Tools",
              href: "https://portal.arbitrum.io/projects/infra-and-tools",
              shouldAddLinkPostfix: true,
              isMobile
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(MenuItemExpandable, { title: "Chains", iconSrc: IconChains, isMobile, children: [
          /* @__PURE__ */ jsx(
            MenuItem,
            {
              title: "Chain Navigator",
              href: "https://portal.arbitrum.io/chains/ecosystem",
              isMobile
            }
          ),
          /* @__PURE__ */ jsx(
            MenuItem,
            {
              title: "Chain Stats",
              href: "https://portal.arbitrum.io/chains/metrics",
              isMobile
            }
          )
        ] }),
        /* @__PURE__ */ jsx(MenuItem, { title: "Bridge", href: BRIDGE_LINK, iconSrc: IconBridge, isMobile }),
        /* @__PURE__ */ jsxs(MenuItemExpandable, { title: "Developers", iconSrc: IconDevelopers, isMobile, children: [
          /* @__PURE__ */ jsx(MenuItem, { isMobile, title: "Learn", href: "https://portal.arbitrum.io/learn" }),
          /* @__PURE__ */ jsx(
            MenuItem,
            {
              isMobile,
              title: "Build & Monitor",
              href: "https://portal.arbitrum.io/build"
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          MenuItem,
          {
            title: "Community",
            iconSrc: IconCommunity,
            isMobile,
            href: "https://portal.arbitrum.io/community"
          }
        ),
        /* @__PURE__ */ jsx(
          MenuItem,
          {
            external: true,
            isMobile,
            title: "Get Help",
            href: GET_HELP_LINK,
            iconSrc: IconGetHelp
          }
        )
      ]
    }
  );
};
const Sidebar = (props) => {
  useSidebarHandlers(props);
  const { sidebarOpened, setSidebarOpened } = useSidebarStore();
  const clickSidePanel = (event) => {
    if (!sidebarOpened) {
      event.preventDefault();
      setSidebarOpened(true);
    }
  };
  const sidebarToggleClick = () => {
    var _a;
    try {
      (_a = props.logger) == null ? void 0 : _a.capture("Sidebar Toggle Clicks", {
        Toggle: sidebarOpened ? "Collapse" : "Expand"
      });
    } catch (error) {
    }
    setSidebarOpened(!sidebarOpened);
  };
  return /* @__PURE__ */ jsx("div", { className: "sticky left-0 top-0 z-10 hidden sm:flex h-full self-start", children: /* @__PURE__ */ jsxs(
    "div",
    {
      onClick: clickSidePanel,
      className: twMerge(
        "relative flex h-screen flex-col border-r border-[#999999] bg-black pt-[20px] transition-all duration-200 pb-[6px]",
        sidebarOpened ? "w-[256px]" : "w-[60px] cursor-pointer"
      ),
      children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: sidebarToggleClick,
            className: twMerge(
              "absolute right-[-16px] top-[60px] flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-full border border-[#999999] bg-[#1a1c1d]",
              !sidebarOpened && "rotate-180"
            ),
            children: /* @__PURE__ */ jsx(ChevronLeftIcon$1, { className: "h-[12px] w-[12px] text-[#999999]" })
          }
        ),
        /* @__PURE__ */ jsx(SidebarHeader, {}),
        /* @__PURE__ */ jsx(SidebarMenu, { children: props.children }),
        /* @__PURE__ */ jsx("div", { className: "flex-grow" }),
        sidebarOpened && /* @__PURE__ */ jsx(SidebarFooter, {})
      ]
    }
  ) });
};
var i$3 = Object.defineProperty;
var d$5 = (t2, e2, n2) => e2 in t2 ? i$3(t2, e2, { enumerable: true, configurable: true, writable: true, value: n2 }) : t2[e2] = n2;
var r$3 = (t2, e2, n2) => (d$5(t2, typeof e2 != "symbol" ? e2 + "" : e2, n2), n2);
let o$5 = class o {
  constructor() {
    r$3(this, "current", this.detect());
    r$3(this, "handoffState", "pending");
    r$3(this, "currentId", 0);
  }
  set(e2) {
    this.current !== e2 && (this.handoffState = "pending", this.currentId = 0, this.current = e2);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
};
let s$7 = new o$5();
let l$4 = (e2, f2) => {
  s$7.isServer ? useEffect(e2, f2) : useLayoutEffect(e2, f2);
};
function s$6(e2) {
  let r2 = useRef(e2);
  return l$4(() => {
    r2.current = e2;
  }, [e2]), r2;
}
let o$4 = function(t2) {
  let e2 = s$6(t2);
  return React__default.useCallback((...r2) => e2.current(...r2), [e2]);
};
function t$6(e2) {
  typeof queueMicrotask == "function" ? queueMicrotask(e2) : Promise.resolve().then(e2).catch((o3) => setTimeout(() => {
    throw o3;
  }));
}
function o$3() {
  let n2 = [], r2 = { addEventListener(e2, t2, s2, a2) {
    return e2.addEventListener(t2, s2, a2), r2.add(() => e2.removeEventListener(t2, s2, a2));
  }, requestAnimationFrame(...e2) {
    let t2 = requestAnimationFrame(...e2);
    return r2.add(() => cancelAnimationFrame(t2));
  }, nextFrame(...e2) {
    return r2.requestAnimationFrame(() => r2.requestAnimationFrame(...e2));
  }, setTimeout(...e2) {
    let t2 = setTimeout(...e2);
    return r2.add(() => clearTimeout(t2));
  }, microTask(...e2) {
    let t2 = { current: true };
    return t$6(() => {
      t2.current && e2[0]();
    }), r2.add(() => {
      t2.current = false;
    });
  }, style(e2, t2, s2) {
    let a2 = e2.style.getPropertyValue(t2);
    return Object.assign(e2.style, { [t2]: s2 }), this.add(() => {
      Object.assign(e2.style, { [t2]: a2 });
    });
  }, group(e2) {
    let t2 = o$3();
    return e2(t2), this.add(() => t2.dispose());
  }, add(e2) {
    return n2.push(e2), () => {
      let t2 = n2.indexOf(e2);
      if (t2 >= 0)
        for (let s2 of n2.splice(t2, 1))
          s2();
    };
  }, dispose() {
    for (let e2 of n2.splice(0))
      e2();
  } };
  return r2;
}
function p$3() {
  let [e2] = useState(o$3);
  return useEffect(() => () => e2.dispose(), [e2]), e2;
}
function s$5() {
  let r2 = typeof document == "undefined";
  return "useSyncExternalStore" in React ? ((o3) => o3.useSyncExternalStore)(React)(() => () => {
  }, () => false, () => !r2) : false;
}
function l$3() {
  let r2 = s$5(), [e2, n2] = React.useState(s$7.isHandoffComplete);
  return e2 && s$7.isHandoffComplete === false && n2(false), React.useEffect(() => {
    e2 !== true && n2(true);
  }, [e2]), React.useEffect(() => s$7.handoff(), []), r2 ? false : e2;
}
var o$2;
let I$4 = (o$2 = React__default.useId) != null ? o$2 : function() {
  let n2 = l$3(), [e2, u2] = React__default.useState(n2 ? () => s$7.nextId() : null);
  return l$4(() => {
    e2 === null && u2(s$7.nextId());
  }, [e2]), e2 != null ? "" + e2 : void 0;
};
function u$4(r2, n2, ...a2) {
  if (r2 in n2) {
    let e2 = n2[r2];
    return typeof e2 == "function" ? e2(...a2) : e2;
  }
  let t2 = new Error(`Tried to handle "${r2}" but there is no handler defined. Only defined handlers are: ${Object.keys(n2).map((e2) => `"${e2}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(t2, u$4), t2;
}
function o$1(r2) {
  return s$7.isServer ? null : r2 instanceof Node ? r2.ownerDocument : r2 != null && r2.hasOwnProperty("current") && r2.current instanceof Node ? r2.current.ownerDocument : document;
}
let c$3 = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e2) => `${e2}:not([tabindex='-1'])`).join(",");
var M = ((n2) => (n2[n2.First = 1] = "First", n2[n2.Previous = 2] = "Previous", n2[n2.Next = 4] = "Next", n2[n2.Last = 8] = "Last", n2[n2.WrapAround = 16] = "WrapAround", n2[n2.NoScroll = 32] = "NoScroll", n2))(M || {}), N$2 = ((o3) => (o3[o3.Error = 0] = "Error", o3[o3.Overflow = 1] = "Overflow", o3[o3.Success = 2] = "Success", o3[o3.Underflow = 3] = "Underflow", o3))(N$2 || {}), F$2 = ((t2) => (t2[t2.Previous = -1] = "Previous", t2[t2.Next = 1] = "Next", t2))(F$2 || {});
function f$5(e2 = document.body) {
  return e2 == null ? [] : Array.from(e2.querySelectorAll(c$3)).sort((r2, t2) => Math.sign((r2.tabIndex || Number.MAX_SAFE_INTEGER) - (t2.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var T$1 = ((t2) => (t2[t2.Strict = 0] = "Strict", t2[t2.Loose = 1] = "Loose", t2))(T$1 || {});
function h$2(e2, r2 = 0) {
  var t2;
  return e2 === ((t2 = o$1(e2)) == null ? void 0 : t2.body) ? false : u$4(r2, { [0]() {
    return e2.matches(c$3);
  }, [1]() {
    let l2 = e2;
    for (; l2 !== null; ) {
      if (l2.matches(c$3))
        return true;
      l2 = l2.parentElement;
    }
    return false;
  } });
}
var w$1 = ((t2) => (t2[t2.Keyboard = 0] = "Keyboard", t2[t2.Mouse = 1] = "Mouse", t2))(w$1 || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e2) => {
  e2.metaKey || e2.altKey || e2.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, true), document.addEventListener("click", (e2) => {
  e2.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e2.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, true));
function y$3(e2) {
  e2 == null || e2.focus({ preventScroll: true });
}
let S$4 = ["textarea", "input"].join(",");
function H(e2) {
  var r2, t2;
  return (t2 = (r2 = e2 == null ? void 0 : e2.matches) == null ? void 0 : r2.call(e2, S$4)) != null ? t2 : false;
}
function I$3(e2, r2 = (t2) => t2) {
  return e2.slice().sort((t2, l2) => {
    let o3 = r2(t2), i2 = r2(l2);
    if (o3 === null || i2 === null)
      return 0;
    let n2 = o3.compareDocumentPosition(i2);
    return n2 & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n2 & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function O$1(e2, r2, { sorted: t2 = true, relativeTo: l2 = null, skipElements: o3 = [] } = {}) {
  let i2 = Array.isArray(e2) ? e2.length > 0 ? e2[0].ownerDocument : document : e2.ownerDocument, n2 = Array.isArray(e2) ? t2 ? I$3(e2) : e2 : f$5(e2);
  o3.length > 0 && n2.length > 1 && (n2 = n2.filter((s2) => !o3.includes(s2))), l2 = l2 != null ? l2 : i2.activeElement;
  let E2 = (() => {
    if (r2 & 5)
      return 1;
    if (r2 & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), x2 = (() => {
    if (r2 & 1)
      return 0;
    if (r2 & 2)
      return Math.max(0, n2.indexOf(l2)) - 1;
    if (r2 & 4)
      return Math.max(0, n2.indexOf(l2)) + 1;
    if (r2 & 8)
      return n2.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), p2 = r2 & 32 ? { preventScroll: true } : {}, d2 = 0, a2 = n2.length, u2;
  do {
    if (d2 >= a2 || d2 + a2 <= 0)
      return 0;
    let s2 = x2 + d2;
    if (r2 & 16)
      s2 = (s2 + a2) % a2;
    else {
      if (s2 < 0)
        return 3;
      if (s2 >= a2)
        return 1;
    }
    u2 = n2[s2], u2 == null || u2.focus(p2), d2 += E2;
  } while (u2 !== i2.activeElement);
  return r2 & 6 && H(u2) && u2.select(), 2;
}
function t$5() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function i$2() {
  return /Android/gi.test(window.navigator.userAgent);
}
function n$3() {
  return t$5() || i$2();
}
function d$4(e2, r2, n2) {
  let o3 = s$6(r2);
  useEffect(() => {
    function t2(u2) {
      o3.current(u2);
    }
    return document.addEventListener(e2, t2, n2), () => document.removeEventListener(e2, t2, n2);
  }, [e2, n2]);
}
function s$4(e2, r2, n2) {
  let o3 = s$6(r2);
  useEffect(() => {
    function t2(i2) {
      o3.current(i2);
    }
    return window.addEventListener(e2, t2, n2), () => window.removeEventListener(e2, t2, n2);
  }, [e2, n2]);
}
function y$2(s2, m2, a2 = true) {
  let i2 = useRef(false);
  useEffect(() => {
    requestAnimationFrame(() => {
      i2.current = a2;
    });
  }, [a2]);
  function c2(e2, r2) {
    if (!i2.current || e2.defaultPrevented)
      return;
    let t2 = r2(e2);
    if (t2 === null || !t2.getRootNode().contains(t2) || !t2.isConnected)
      return;
    let E2 = function u2(n2) {
      return typeof n2 == "function" ? u2(n2()) : Array.isArray(n2) || n2 instanceof Set ? n2 : [n2];
    }(s2);
    for (let u2 of E2) {
      if (u2 === null)
        continue;
      let n2 = u2 instanceof HTMLElement ? u2 : u2.current;
      if (n2 != null && n2.contains(t2) || e2.composed && e2.composedPath().includes(n2))
        return;
    }
    return !h$2(t2, T$1.Loose) && t2.tabIndex !== -1 && e2.preventDefault(), m2(e2, t2);
  }
  let o3 = useRef(null);
  d$4("pointerdown", (e2) => {
    var r2, t2;
    i2.current && (o3.current = ((t2 = (r2 = e2.composedPath) == null ? void 0 : r2.call(e2)) == null ? void 0 : t2[0]) || e2.target);
  }, true), d$4("mousedown", (e2) => {
    var r2, t2;
    i2.current && (o3.current = ((t2 = (r2 = e2.composedPath) == null ? void 0 : r2.call(e2)) == null ? void 0 : t2[0]) || e2.target);
  }, true), d$4("click", (e2) => {
    n$3() || o3.current && (c2(e2, () => o3.current), o3.current = null);
  }, true), d$4("touchend", (e2) => c2(e2, () => e2.target instanceof HTMLElement ? e2.target : null), true), s$4("blur", (e2) => c2(e2, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), true);
}
function n$2(...e2) {
  return useMemo(() => o$1(...e2), [...e2]);
}
let u$3 = Symbol();
function T(t2, n2 = true) {
  return Object.assign(t2, { [u$3]: n2 });
}
function y$1(...t2) {
  let n2 = useRef(t2);
  useEffect(() => {
    n2.current = t2;
  }, [t2]);
  let c2 = o$4((e2) => {
    for (let o3 of n2.current)
      o3 != null && (typeof o3 == "function" ? o3(e2) : o3.current = e2);
  });
  return t2.every((e2) => e2 == null || (e2 == null ? void 0 : e2[u$3])) ? void 0 : c2;
}
function m$2(u2, t2) {
  let e2 = useRef([]), r2 = o$4(u2);
  useEffect(() => {
    let o3 = [...e2.current];
    for (let [n2, a2] of t2.entries())
      if (e2.current[n2] !== a2) {
        let l2 = r2(t2, o3);
        return e2.current = t2, l2;
      }
  }, [r2, ...t2]);
}
function t$4(...r2) {
  return Array.from(new Set(r2.flatMap((n2) => typeof n2 == "string" ? n2.split(" ") : []))).filter(Boolean).join(" ");
}
var O = ((n2) => (n2[n2.None = 0] = "None", n2[n2.RenderStrategy = 1] = "RenderStrategy", n2[n2.Static = 2] = "Static", n2))(O || {}), v = ((e2) => (e2[e2.Unmount = 0] = "Unmount", e2[e2.Hidden = 1] = "Hidden", e2))(v || {});
function C({ ourProps: r2, theirProps: t2, slot: e2, defaultTag: n2, features: o3, visible: a2 = true, name: f2, mergeRefs: l2 }) {
  l2 = l2 != null ? l2 : k;
  let s2 = R(t2, r2);
  if (a2)
    return m$1(s2, e2, n2, f2, l2);
  let y2 = o3 != null ? o3 : 0;
  if (y2 & 2) {
    let { static: u2 = false, ...d2 } = s2;
    if (u2)
      return m$1(d2, e2, n2, f2, l2);
  }
  if (y2 & 1) {
    let { unmount: u2 = true, ...d2 } = s2;
    return u$4(u2 ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return m$1({ ...d2, hidden: true, style: { display: "none" } }, e2, n2, f2, l2);
    } });
  }
  return m$1(s2, e2, n2, f2, l2);
}
function m$1(r2, t2 = {}, e2, n2, o3) {
  let { as: a2 = e2, children: f2, refName: l2 = "ref", ...s2 } = F$1(r2, ["unmount", "static"]), y2 = r2.ref !== void 0 ? { [l2]: r2.ref } : {}, u2 = typeof f2 == "function" ? f2(t2) : f2;
  "className" in s2 && s2.className && typeof s2.className == "function" && (s2.className = s2.className(t2));
  let d2 = {};
  if (t2) {
    let i2 = false, c2 = [];
    for (let [T2, p2] of Object.entries(t2))
      typeof p2 == "boolean" && (i2 = true), p2 === true && c2.push(T2);
    i2 && (d2["data-headlessui-state"] = c2.join(" "));
  }
  if (a2 === Fragment$1 && Object.keys(x$1(s2)).length > 0) {
    if (!isValidElement(u2) || Array.isArray(u2) && u2.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${n2} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(s2).map((p2) => `  - ${p2}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((p2) => `  - ${p2}`).join(`
`)].join(`
`));
    let i2 = u2.props, c2 = typeof (i2 == null ? void 0 : i2.className) == "function" ? (...p2) => t$4(i2 == null ? void 0 : i2.className(...p2), s2.className) : t$4(i2 == null ? void 0 : i2.className, s2.className), T2 = c2 ? { className: c2 } : {};
    return cloneElement(u2, Object.assign({}, R(u2.props, x$1(F$1(s2, ["ref"]))), d2, y2, { ref: o3(u2.ref, y2.ref) }, T2));
  }
  return createElement(a2, Object.assign({}, F$1(s2, ["ref"]), a2 !== Fragment$1 && y2, a2 !== Fragment$1 && d2), u2);
}
function k(...r2) {
  return r2.every((t2) => t2 == null) ? void 0 : (t2) => {
    for (let e2 of r2)
      e2 != null && (typeof e2 == "function" ? e2(t2) : e2.current = t2);
  };
}
function R(...r2) {
  if (r2.length === 0)
    return {};
  if (r2.length === 1)
    return r2[0];
  let t2 = {}, e2 = {};
  for (let o3 of r2)
    for (let a2 in o3)
      a2.startsWith("on") && typeof o3[a2] == "function" ? (e2[a2] != null || (e2[a2] = []), e2[a2].push(o3[a2])) : t2[a2] = o3[a2];
  if (t2.disabled || t2["aria-disabled"])
    return Object.assign(t2, Object.fromEntries(Object.keys(e2).map((o3) => [o3, void 0])));
  for (let o3 in e2)
    Object.assign(t2, { [o3](a2, ...f2) {
      let l2 = e2[o3];
      for (let s2 of l2) {
        if ((a2 instanceof Event || (a2 == null ? void 0 : a2.nativeEvent) instanceof Event) && a2.defaultPrevented)
          return;
        s2(a2, ...f2);
      }
    } });
  return t2;
}
function U$1(r2) {
  var t2;
  return Object.assign(forwardRef(r2), { displayName: (t2 = r2.displayName) != null ? t2 : r2.name });
}
function x$1(r2) {
  let t2 = Object.assign({}, r2);
  for (let e2 in t2)
    t2[e2] === void 0 && delete t2[e2];
  return t2;
}
function F$1(r2, t2 = []) {
  let e2 = Object.assign({}, r2);
  for (let n2 of t2)
    n2 in e2 && delete e2[n2];
  return e2;
}
let p$2 = "div";
var s$3 = ((e2) => (e2[e2.None = 1] = "None", e2[e2.Focusable = 2] = "Focusable", e2[e2.Hidden = 4] = "Hidden", e2))(s$3 || {});
function l$2(d2, o3) {
  var n2;
  let { features: t2 = 1, ...e2 } = d2, r2 = { ref: o3, "aria-hidden": (t2 & 2) === 2 ? true : (n2 = e2["aria-hidden"]) != null ? n2 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(t2 & 4) === 4 && (t2 & 2) !== 2 && { display: "none" } } };
  return C({ ourProps: r2, theirProps: e2, slot: {}, defaultTag: p$2, name: "Hidden" });
}
let f$4 = U$1(l$2);
let n$1 = createContext(null);
n$1.displayName = "OpenClosedContext";
var d$3 = ((e2) => (e2[e2.Open = 1] = "Open", e2[e2.Closed = 2] = "Closed", e2[e2.Closing = 4] = "Closing", e2[e2.Opening = 8] = "Opening", e2))(d$3 || {});
function u$2() {
  return useContext(n$1);
}
function t$3(n2) {
  function e2() {
    document.readyState !== "loading" && (n2(), document.removeEventListener("DOMContentLoaded", e2));
  }
  typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e2), e2());
}
let t$2 = [];
t$3(() => {
  function e2(n2) {
    n2.target instanceof HTMLElement && n2.target !== document.body && t$2[0] !== n2.target && (t$2.unshift(n2.target), t$2 = t$2.filter((r2) => r2 != null && r2.isConnected), t$2.splice(10));
  }
  window.addEventListener("click", e2, { capture: true }), window.addEventListener("mousedown", e2, { capture: true }), window.addEventListener("focus", e2, { capture: true }), document.body.addEventListener("click", e2, { capture: true }), document.body.addEventListener("mousedown", e2, { capture: true }), document.body.addEventListener("focus", e2, { capture: true });
});
function r$2(n2) {
  let e2 = n2.parentElement, l2 = null;
  for (; e2 && !(e2 instanceof HTMLFieldSetElement); )
    e2 instanceof HTMLLegendElement && (l2 = e2), e2 = e2.parentElement;
  let t2 = (e2 == null ? void 0 : e2.getAttribute("disabled")) === "";
  return t2 && i$1(l2) ? false : t2;
}
function i$1(n2) {
  if (!n2)
    return false;
  let e2 = n2.previousElementSibling;
  for (; e2 !== null; ) {
    if (e2 instanceof HTMLLegendElement)
      return false;
    e2 = e2.previousElementSibling;
  }
  return true;
}
var o2 = ((r2) => (r2.Space = " ", r2.Enter = "Enter", r2.Escape = "Escape", r2.Backspace = "Backspace", r2.Delete = "Delete", r2.ArrowLeft = "ArrowLeft", r2.ArrowUp = "ArrowUp", r2.ArrowRight = "ArrowRight", r2.ArrowDown = "ArrowDown", r2.Home = "Home", r2.End = "End", r2.PageUp = "PageUp", r2.PageDown = "PageDown", r2.Tab = "Tab", r2))(o2 || {});
function E(n2, e2, a2, t2) {
  let i2 = s$6(a2);
  useEffect(() => {
    n2 = n2 != null ? n2 : window;
    function r2(o3) {
      i2.current(o3);
    }
    return n2.addEventListener(e2, r2, t2), () => n2.removeEventListener(e2, r2, t2);
  }, [n2, e2, t2]);
}
function f$3() {
  let e2 = useRef(false);
  return l$4(() => (e2.current = true, () => {
    e2.current = false;
  }), []), e2;
}
function c$2(t2) {
  let r2 = o$4(t2), e2 = useRef(false);
  useEffect(() => (e2.current = false, () => {
    e2.current = true, t$6(() => {
      e2.current && r2();
    });
  }), [r2]);
}
var s$2 = ((r2) => (r2[r2.Forwards = 0] = "Forwards", r2[r2.Backwards = 1] = "Backwards", r2))(s$2 || {});
function n() {
  let e2 = useRef(0);
  return s$4("keydown", (o3) => {
    o3.key === "Tab" && (e2.current = o3.shiftKey ? 1 : 0);
  }, true), e2;
}
function P(t2) {
  if (!t2)
    return /* @__PURE__ */ new Set();
  if (typeof t2 == "function")
    return new Set(t2());
  let n2 = /* @__PURE__ */ new Set();
  for (let e2 of t2.current)
    e2.current instanceof HTMLElement && n2.add(e2.current);
  return n2;
}
let X = "div";
var _$1 = ((r2) => (r2[r2.None = 1] = "None", r2[r2.InitialFocus = 2] = "InitialFocus", r2[r2.TabLock = 4] = "TabLock", r2[r2.FocusLock = 8] = "FocusLock", r2[r2.RestoreFocus = 16] = "RestoreFocus", r2[r2.All = 30] = "All", r2))(_$1 || {});
function z(t2, n$12) {
  let e2 = useRef(null), o3 = y$1(e2, n$12), { initialFocus: l2, containers: c2, features: r2 = 30, ...s2 } = t2;
  l$3() || (r2 = 1);
  let i2 = n$2(e2);
  Y({ ownerDocument: i2 }, Boolean(r2 & 16));
  let u2 = Z({ ownerDocument: i2, container: e2, initialFocus: l2 }, Boolean(r2 & 2));
  $({ ownerDocument: i2, container: e2, containers: c2, previousActiveElement: u2 }, Boolean(r2 & 8));
  let y2 = n(), R2 = o$4((a2) => {
    let m2 = e2.current;
    if (!m2)
      return;
    ((B) => B())(() => {
      u$4(y2.current, { [s$2.Forwards]: () => {
        O$1(m2, M.First, { skipElements: [a2.relatedTarget] });
      }, [s$2.Backwards]: () => {
        O$1(m2, M.Last, { skipElements: [a2.relatedTarget] });
      } });
    });
  }), h2 = p$3(), H2 = useRef(false), j2 = { ref: o3, onKeyDown(a2) {
    a2.key == "Tab" && (H2.current = true, h2.requestAnimationFrame(() => {
      H2.current = false;
    }));
  }, onBlur(a2) {
    let m2 = P(c2);
    e2.current instanceof HTMLElement && m2.add(e2.current);
    let T2 = a2.relatedTarget;
    T2 instanceof HTMLElement && T2.dataset.headlessuiFocusGuard !== "true" && (S$3(m2, T2) || (H2.current ? O$1(e2.current, u$4(y2.current, { [s$2.Forwards]: () => M.Next, [s$2.Backwards]: () => M.Previous }) | M.WrapAround, { relativeTo: a2.target }) : a2.target instanceof HTMLElement && y$3(a2.target)));
  } };
  return React__default.createElement(React__default.Fragment, null, Boolean(r2 & 4) && React__default.createElement(f$4, { as: "button", type: "button", "data-headlessui-focus-guard": true, onFocus: R2, features: s$3.Focusable }), C({ ourProps: j2, theirProps: s2, defaultTag: X, name: "FocusTrap" }), Boolean(r2 & 4) && React__default.createElement(f$4, { as: "button", type: "button", "data-headlessui-focus-guard": true, onFocus: R2, features: s$3.Focusable }));
}
let D$1 = U$1(z), de = Object.assign(D$1, { features: _$1 });
function Q(t2 = true) {
  let n2 = useRef(t$2.slice());
  return m$2(([e2], [o3]) => {
    o3 === true && e2 === false && t$6(() => {
      n2.current.splice(0);
    }), o3 === false && e2 === true && (n2.current = t$2.slice());
  }, [t2, t$2, n2]), o$4(() => {
    var e2;
    return (e2 = n2.current.find((o3) => o3 != null && o3.isConnected)) != null ? e2 : null;
  });
}
function Y({ ownerDocument: t2 }, n2) {
  let e2 = Q(n2);
  m$2(() => {
    n2 || (t2 == null ? void 0 : t2.activeElement) === (t2 == null ? void 0 : t2.body) && y$3(e2());
  }, [n2]), c$2(() => {
    n2 && y$3(e2());
  });
}
function Z({ ownerDocument: t2, container: n2, initialFocus: e2 }, o3) {
  let l2 = useRef(null), c2 = f$3();
  return m$2(() => {
    if (!o3)
      return;
    let r2 = n2.current;
    r2 && t$6(() => {
      if (!c2.current)
        return;
      let s2 = t2 == null ? void 0 : t2.activeElement;
      if (e2 != null && e2.current) {
        if ((e2 == null ? void 0 : e2.current) === s2) {
          l2.current = s2;
          return;
        }
      } else if (r2.contains(s2)) {
        l2.current = s2;
        return;
      }
      e2 != null && e2.current ? y$3(e2.current) : O$1(r2, M.First) === N$2.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), l2.current = t2 == null ? void 0 : t2.activeElement;
    });
  }, [o3]), l2;
}
function $({ ownerDocument: t2, container: n2, containers: e2, previousActiveElement: o3 }, l2) {
  let c2 = f$3();
  E(t2 == null ? void 0 : t2.defaultView, "focus", (r2) => {
    if (!l2 || !c2.current)
      return;
    let s2 = P(e2);
    n2.current instanceof HTMLElement && s2.add(n2.current);
    let i2 = o3.current;
    if (!i2)
      return;
    let u2 = r2.target;
    u2 && u2 instanceof HTMLElement ? S$3(s2, u2) ? (o3.current = u2, y$3(u2)) : (r2.preventDefault(), r2.stopPropagation(), y$3(i2)) : y$3(o3.current);
  }, true);
}
function S$3(t2, n2) {
  for (let e2 of t2)
    if (e2.contains(n2))
      return true;
  return false;
}
let e = createContext(false);
function a$4() {
  return useContext(e);
}
function l$1(o3) {
  return React__default.createElement(e.Provider, { value: o3.force }, o3.children);
}
function F(p2) {
  let n2 = a$4(), l2 = useContext(_), e2 = n$2(p2), [a2, o3] = useState(() => {
    if (!n2 && l2 !== null || s$7.isServer)
      return null;
    let t2 = e2 == null ? void 0 : e2.getElementById("headlessui-portal-root");
    if (t2)
      return t2;
    if (e2 === null)
      return null;
    let r2 = e2.createElement("div");
    return r2.setAttribute("id", "headlessui-portal-root"), e2.body.appendChild(r2);
  });
  return useEffect(() => {
    a2 !== null && (e2 != null && e2.body.contains(a2) || e2 == null || e2.body.appendChild(a2));
  }, [a2, e2]), useEffect(() => {
    n2 || l2 !== null && o3(l2.current);
  }, [l2, o3, n2]), a2;
}
let U = Fragment$1;
function N$1(p2, n2) {
  let l2 = p2, e2 = useRef(null), a2 = y$1(T((u2) => {
    e2.current = u2;
  }), n2), o3 = n$2(e2), t2 = F(e2), [r2] = useState(() => {
    var u2;
    return s$7.isServer ? null : (u2 = o3 == null ? void 0 : o3.createElement("div")) != null ? u2 : null;
  }), i2 = useContext(f$2), v2 = l$3();
  return l$4(() => {
    !t2 || !r2 || t2.contains(r2) || (r2.setAttribute("data-headlessui-portal", ""), t2.appendChild(r2));
  }, [t2, r2]), l$4(() => {
    if (r2 && i2)
      return i2.register(r2);
  }, [i2, r2]), c$2(() => {
    var u2;
    !t2 || !r2 || (r2 instanceof Node && t2.contains(r2) && t2.removeChild(r2), t2.childNodes.length <= 0 && ((u2 = t2.parentElement) == null || u2.removeChild(t2)));
  }), v2 ? !t2 || !r2 ? null : createPortal(C({ ourProps: { ref: a2 }, theirProps: l2, defaultTag: U, name: "Portal" }), r2) : null;
}
let S$2 = Fragment$1, _ = createContext(null);
function j(p2, n2) {
  let { target: l2, ...e2 } = p2, o3 = { ref: y$1(n2) };
  return React__default.createElement(_.Provider, { value: l2 }, C({ ourProps: o3, theirProps: e2, defaultTag: S$2, name: "Popover.Group" }));
}
let f$2 = createContext(null);
function ee() {
  let p2 = useContext(f$2), n2 = useRef([]), l2 = o$4((o3) => (n2.current.push(o3), p2 && p2.register(o3), () => e2(o3))), e2 = o$4((o3) => {
    let t2 = n2.current.indexOf(o3);
    t2 !== -1 && n2.current.splice(t2, 1), p2 && p2.unregister(o3);
  }), a2 = useMemo(() => ({ register: l2, unregister: e2, portals: n2 }), [l2, e2, n2]);
  return [n2, useMemo(() => function({ children: t2 }) {
    return React__default.createElement(f$2.Provider, { value: a2 }, t2);
  }, [a2])];
}
let D = U$1(N$1), I$2 = U$1(j), te = Object.assign(D, { Group: I$2 });
function i(e2, t2) {
  return e2 === t2 && (e2 !== 0 || 1 / e2 === 1 / t2) || e2 !== e2 && t2 !== t2;
}
const d$2 = typeof Object.is == "function" ? Object.is : i, { useState: u$1, useEffect: h$1, useLayoutEffect: f$1, useDebugValue: p$1 } = React;
function y(e2, t2, c2) {
  const a2 = t2(), [{ inst: n2 }, o3] = u$1({ inst: { value: a2, getSnapshot: t2 } });
  return f$1(() => {
    n2.value = a2, n2.getSnapshot = t2, r$1(n2) && o3({ inst: n2 });
  }, [e2, a2, t2]), h$1(() => (r$1(n2) && o3({ inst: n2 }), e2(() => {
    r$1(n2) && o3({ inst: n2 });
  })), [e2]), p$1(a2), a2;
}
function r$1(e2) {
  const t2 = e2.getSnapshot, c2 = e2.value;
  try {
    const a2 = t2();
    return !d$2(c2, a2);
  } catch {
    return true;
  }
}
function t$1(r2, e2, n2) {
  return e2();
}
const r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", s$1 = !r, c$1 = s$1 ? t$1 : y, a$3 = "useSyncExternalStore" in React ? ((n2) => n2.useSyncExternalStore)(React) : c$1;
function S$1(t2) {
  return a$3(t2.subscribe, t2.getSnapshot, t2.getSnapshot);
}
function a$2(o3, r2) {
  let t2 = o3(), n2 = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return t2;
  }, subscribe(e2) {
    return n2.add(e2), () => n2.delete(e2);
  }, dispatch(e2, ...s2) {
    let i2 = r2[e2].call(t2, ...s2);
    i2 && (t2 = i2, n2.forEach((c2) => c2()));
  } };
}
function c() {
  let o3;
  return { before({ doc: e2 }) {
    var l2;
    let n2 = e2.documentElement;
    o3 = ((l2 = e2.defaultView) != null ? l2 : window).innerWidth - n2.clientWidth;
  }, after({ doc: e2, d: n2 }) {
    let t2 = e2.documentElement, l2 = t2.clientWidth - t2.offsetWidth, r2 = o3 - l2;
    n2.style(t2, "paddingRight", `${r2}px`);
  } };
}
function d$1() {
  return t$5() ? { before({ doc: r2, d: l2, meta: c2 }) {
    function o3(a2) {
      return c2.containers.flatMap((n2) => n2()).some((n2) => n2.contains(a2));
    }
    l2.microTask(() => {
      var s2;
      if (window.getComputedStyle(r2.documentElement).scrollBehavior !== "auto") {
        let t2 = o$3();
        t2.style(r2.documentElement, "scrollBehavior", "auto"), l2.add(() => l2.microTask(() => t2.dispose()));
      }
      let a2 = (s2 = window.scrollY) != null ? s2 : window.pageYOffset, n2 = null;
      l2.addEventListener(r2, "click", (t2) => {
        if (t2.target instanceof HTMLElement)
          try {
            let e2 = t2.target.closest("a");
            if (!e2)
              return;
            let { hash: f2 } = new URL(e2.href), i2 = r2.querySelector(f2);
            i2 && !o3(i2) && (n2 = i2);
          } catch {
          }
      }, true), l2.addEventListener(r2, "touchstart", (t2) => {
        if (t2.target instanceof HTMLElement)
          if (o3(t2.target)) {
            let e2 = t2.target;
            for (; e2.parentElement && o3(e2.parentElement); )
              e2 = e2.parentElement;
            l2.style(e2, "overscrollBehavior", "contain");
          } else
            l2.style(t2.target, "touchAction", "none");
      }), l2.addEventListener(r2, "touchmove", (t2) => {
        if (t2.target instanceof HTMLElement)
          if (o3(t2.target)) {
            let e2 = t2.target;
            for (; e2.parentElement && e2.dataset.headlessuiPortal !== "" && !(e2.scrollHeight > e2.clientHeight || e2.scrollWidth > e2.clientWidth); )
              e2 = e2.parentElement;
            e2.dataset.headlessuiPortal === "" && t2.preventDefault();
          } else
            t2.preventDefault();
      }, { passive: false }), l2.add(() => {
        var e2;
        let t2 = (e2 = window.scrollY) != null ? e2 : window.pageYOffset;
        a2 !== t2 && window.scrollTo(0, a2), n2 && n2.isConnected && (n2.scrollIntoView({ block: "nearest" }), n2 = null);
      });
    });
  } } : {};
}
function l() {
  return { before({ doc: e2, d: o3 }) {
    o3.style(e2.documentElement, "overflow", "hidden");
  } };
}
function m(e2) {
  let n2 = {};
  for (let t2 of e2)
    Object.assign(n2, t2(n2));
  return n2;
}
let a$1 = a$2(() => /* @__PURE__ */ new Map(), { PUSH(e2, n2) {
  var o3;
  let t2 = (o3 = this.get(e2)) != null ? o3 : { doc: e2, count: 0, d: o$3(), meta: /* @__PURE__ */ new Set() };
  return t2.count++, t2.meta.add(n2), this.set(e2, t2), this;
}, POP(e2, n2) {
  let t2 = this.get(e2);
  return t2 && (t2.count--, t2.meta.delete(n2)), this;
}, SCROLL_PREVENT({ doc: e2, d: n2, meta: t2 }) {
  let o3 = { doc: e2, d: n2, meta: m(t2) }, c$12 = [d$1(), c(), l()];
  c$12.forEach(({ before: r2 }) => r2 == null ? void 0 : r2(o3)), c$12.forEach(({ after: r2 }) => r2 == null ? void 0 : r2(o3));
}, SCROLL_ALLOW({ d: e2 }) {
  e2.dispose();
}, TEARDOWN({ doc: e2 }) {
  this.delete(e2);
} });
a$1.subscribe(() => {
  let e2 = a$1.getSnapshot(), n2 = /* @__PURE__ */ new Map();
  for (let [t2] of e2)
    n2.set(t2, t2.documentElement.style.overflow);
  for (let t2 of e2.values()) {
    let o3 = n2.get(t2.doc) === "hidden", c2 = t2.count !== 0;
    (c2 && !o3 || !c2 && o3) && a$1.dispatch(t2.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t2), t2.count === 0 && a$1.dispatch("TEARDOWN", t2);
  }
});
function p(e2, r2, n2) {
  let f2 = S$1(a$1), o3 = e2 ? f2.get(e2) : void 0, i2 = o3 ? o3.count > 0 : false;
  return l$4(() => {
    if (!(!e2 || !r2))
      return a$1.dispatch("PUSH", e2, n2), () => a$1.dispatch("POP", e2, n2);
  }, [r2, e2]), i2;
}
let u = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
function b$2(r2, l2 = true) {
  l$4(() => {
    var o3;
    if (!l2)
      return;
    let e2 = typeof r2 == "function" ? r2() : r2.current;
    if (!e2)
      return;
    function a2() {
      var d2;
      if (!e2)
        return;
      let i2 = (d2 = t.get(e2)) != null ? d2 : 1;
      if (i2 === 1 ? t.delete(e2) : t.set(e2, i2 - 1), i2 !== 1)
        return;
      let n2 = u.get(e2);
      n2 && (n2["aria-hidden"] === null ? e2.removeAttribute("aria-hidden") : e2.setAttribute("aria-hidden", n2["aria-hidden"]), e2.inert = n2.inert, u.delete(e2));
    }
    let f2 = (o3 = t.get(e2)) != null ? o3 : 0;
    return t.set(e2, f2 + 1), f2 !== 0 || (u.set(e2, { "aria-hidden": e2.getAttribute("aria-hidden"), inert: e2.inert }), e2.setAttribute("aria-hidden", "true"), e2.inert = true), a2;
  }, [r2, l2]);
}
function N({ defaultContainers: o3 = [], portals: r2, mainTreeNodeRef: u2 } = {}) {
  var f2;
  let t2 = useRef((f2 = u2 == null ? void 0 : u2.current) != null ? f2 : null), l2 = n$2(t2), c2 = o$4(() => {
    var i2, s2, a2;
    let n2 = [];
    for (let e2 of o3)
      e2 !== null && (e2 instanceof HTMLElement ? n2.push(e2) : "current" in e2 && e2.current instanceof HTMLElement && n2.push(e2.current));
    if (r2 != null && r2.current)
      for (let e2 of r2.current)
        n2.push(e2);
    for (let e2 of (i2 = l2 == null ? void 0 : l2.querySelectorAll("html > *, body > *")) != null ? i2 : [])
      e2 !== document.body && e2 !== document.head && e2 instanceof HTMLElement && e2.id !== "headlessui-portal-root" && (e2.contains(t2.current) || e2.contains((a2 = (s2 = t2.current) == null ? void 0 : s2.getRootNode()) == null ? void 0 : a2.host) || n2.some((L) => e2.contains(L)) || n2.push(e2));
    return n2;
  });
  return { resolveContainers: c2, contains: o$4((n2) => c2().some((i2) => i2.contains(n2))), mainTreeNodeRef: t2, MainTreeNode: useMemo(() => function() {
    return u2 != null ? null : React__default.createElement(f$4, { features: s$3.Hidden, ref: t2 });
  }, [t2, u2]) };
}
let a = createContext(() => {
});
a.displayName = "StackContext";
var s = ((e2) => (e2[e2.Add = 0] = "Add", e2[e2.Remove = 1] = "Remove", e2))(s || {});
function x() {
  return useContext(a);
}
function b$1({ children: i2, onUpdate: r2, type: e2, element: n2, enabled: u2 }) {
  let l2 = x(), o3 = o$4((...t2) => {
    r2 == null || r2(...t2), l2(...t2);
  });
  return l$4(() => {
    let t2 = u2 === void 0 || u2 === true;
    return t2 && o3(0, e2, n2), () => {
      t2 && o3(1, e2, n2);
    };
  }, [o3, e2, n2, u2]), React__default.createElement(a.Provider, { value: o3 }, i2);
}
let d = createContext(null);
function f() {
  let r2 = useContext(d);
  if (r2 === null) {
    let t2 = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t2, f), t2;
  }
  return r2;
}
function w() {
  let [r2, t2] = useState([]);
  return [r2.length > 0 ? r2.join(" ") : void 0, useMemo(() => function(e2) {
    let i2 = o$4((s2) => (t2((o3) => [...o3, s2]), () => t2((o3) => {
      let p2 = o3.slice(), c2 = p2.indexOf(s2);
      return c2 !== -1 && p2.splice(c2, 1), p2;
    }))), n2 = useMemo(() => ({ register: i2, slot: e2.slot, name: e2.name, props: e2.props }), [i2, e2.slot, e2.name, e2.props]);
    return React__default.createElement(d.Provider, { value: n2 }, e2.children);
  }, [t2])];
}
let I$1 = "p";
function S(r2, t2) {
  let a2 = I$4(), { id: e2 = `headlessui-description-${a2}`, ...i2 } = r2, n2 = f(), s2 = y$1(t2);
  l$4(() => n2.register(e2), [e2, n2.register]);
  let o3 = { ref: s2, ...n2.props, id: e2 };
  return C({ ourProps: o3, theirProps: i2, slot: n2.slot || {}, defaultTag: I$1, name: n2.name || "Description" });
}
let h = U$1(S), G = Object.assign(h, {});
var Me = ((r2) => (r2[r2.Open = 0] = "Open", r2[r2.Closed = 1] = "Closed", r2))(Me || {}), we = ((e2) => (e2[e2.SetTitleId = 0] = "SetTitleId", e2))(we || {});
let He = { [0](t2, e2) {
  return t2.titleId === e2.id ? t2 : { ...t2, titleId: e2.id };
} }, I = createContext(null);
I.displayName = "DialogContext";
function b(t2) {
  let e2 = useContext(I);
  if (e2 === null) {
    let r2 = new Error(`<${t2} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r2, b), r2;
  }
  return e2;
}
function Be(t2, e2, r2 = () => [document.body]) {
  p(t2, e2, (i2) => {
    var n2;
    return { containers: [...(n2 = i2.containers) != null ? n2 : [], r2] };
  });
}
function Ge(t2, e2) {
  return u$4(e2.type, He, t2, e2);
}
let Ne = "div", Ue = O.RenderStrategy | O.Static;
function We(t2, e2) {
  let r2 = I$4(), { id: i2 = `headlessui-dialog-${r2}`, open: n2, onClose: l2, initialFocus: s$12, role: a2 = "dialog", __demoMode: T2 = false, ...m2 } = t2, [M2, f2] = useState(0), U2 = useRef(false);
  a2 = function() {
    return a2 === "dialog" || a2 === "alertdialog" ? a2 : (U2.current || (U2.current = true, console.warn(`Invalid role [${a2}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let E$1 = u$2();
  n2 === void 0 && E$1 !== null && (n2 = (E$1 & d$3.Open) === d$3.Open);
  let D2 = useRef(null), ee$1 = y$1(D2, e2), g = n$2(D2), W = t2.hasOwnProperty("open") || E$1 !== null, $2 = t2.hasOwnProperty("onClose");
  if (!W && !$2)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!W)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!$2)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof n2 != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n2}`);
  if (typeof l2 != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l2}`);
  let p2 = n2 ? 0 : 1, [h2, te$1] = useReducer(Ge, { titleId: null, descriptionId: null, panelRef: createRef() }), P2 = o$4(() => l2(false)), Y2 = o$4((o3) => te$1({ type: 0, id: o3 })), S2 = l$3() ? T2 ? false : p2 === 0 : false, x2 = M2 > 1, j2 = useContext(I) !== null, [oe, re] = ee(), ne = { get current() {
    var o3;
    return (o3 = h2.panelRef.current) != null ? o3 : D2.current;
  } }, { resolveContainers: w$12, mainTreeNodeRef: L, MainTreeNode: le } = N({ portals: oe, defaultContainers: [ne] }), ae = x2 ? "parent" : "leaf", J = E$1 !== null ? (E$1 & d$3.Closing) === d$3.Closing : false, ie = (() => j2 || J ? false : S2)(), se = useCallback(() => {
    var o3, c2;
    return (c2 = Array.from((o3 = g == null ? void 0 : g.querySelectorAll("body > *")) != null ? o3 : []).find((d2) => d2.id === "headlessui-portal-root" ? false : d2.contains(L.current) && d2 instanceof HTMLElement)) != null ? c2 : null;
  }, [L]);
  b$2(se, ie);
  let pe = (() => x2 ? true : S2)(), de$1 = useCallback(() => {
    var o3, c2;
    return (c2 = Array.from((o3 = g == null ? void 0 : g.querySelectorAll("[data-headlessui-portal]")) != null ? o3 : []).find((d2) => d2.contains(L.current) && d2 instanceof HTMLElement)) != null ? c2 : null;
  }, [L]);
  b$2(de$1, pe);
  let ue = (() => !(!S2 || x2))();
  y$2(w$12, P2, ue);
  let fe = (() => !(x2 || p2 !== 0))();
  E(g == null ? void 0 : g.defaultView, "keydown", (o$12) => {
    fe && (o$12.defaultPrevented || o$12.key === o2.Escape && (o$12.preventDefault(), o$12.stopPropagation(), P2()));
  });
  let ge = (() => !(J || p2 !== 0 || j2))();
  Be(g, ge, w$12), useEffect(() => {
    if (p2 !== 0 || !D2.current)
      return;
    let o3 = new ResizeObserver((c2) => {
      for (let d2 of c2) {
        let F2 = d2.target.getBoundingClientRect();
        F2.x === 0 && F2.y === 0 && F2.width === 0 && F2.height === 0 && P2();
      }
    });
    return o3.observe(D2.current), () => o3.disconnect();
  }, [p2, D2, P2]);
  let [Te, ce] = w(), De = useMemo(() => [{ dialogState: p2, close: P2, setTitleId: Y2 }, h2], [p2, h2, P2, Y2]), X2 = useMemo(() => ({ open: p2 === 0 }), [p2]), me = { ref: ee$1, id: i2, role: a2, "aria-modal": p2 === 0 ? true : void 0, "aria-labelledby": h2.titleId, "aria-describedby": Te };
  return React__default.createElement(b$1, { type: "Dialog", enabled: p2 === 0, element: D2, onUpdate: o$4((o3, c2) => {
    c2 === "Dialog" && u$4(o3, { [s.Add]: () => f2((d2) => d2 + 1), [s.Remove]: () => f2((d2) => d2 - 1) });
  }) }, React__default.createElement(l$1, { force: true }, React__default.createElement(te, null, React__default.createElement(I.Provider, { value: De }, React__default.createElement(te.Group, { target: D2 }, React__default.createElement(l$1, { force: false }, React__default.createElement(ce, { slot: X2, name: "Dialog.Description" }, React__default.createElement(de, { initialFocus: s$12, containers: w$12, features: S2 ? u$4(ae, { parent: de.features.RestoreFocus, leaf: de.features.All & ~de.features.FocusLock }) : de.features.None }, React__default.createElement(re, null, C({ ourProps: me, theirProps: m2, slot: X2, defaultTag: Ne, features: Ue, visible: p2 === 0, name: "Dialog" }))))))))), React__default.createElement(le, null));
}
let $e = "div";
function Ye(t2, e2) {
  let r2 = I$4(), { id: i2 = `headlessui-dialog-overlay-${r2}`, ...n2 } = t2, [{ dialogState: l2, close: s2 }] = b("Dialog.Overlay"), a2 = y$1(e2), T2 = o$4((f2) => {
    if (f2.target === f2.currentTarget) {
      if (r$2(f2.currentTarget))
        return f2.preventDefault();
      f2.preventDefault(), f2.stopPropagation(), s2();
    }
  }), m2 = useMemo(() => ({ open: l2 === 0 }), [l2]);
  return C({ ourProps: { ref: a2, id: i2, "aria-hidden": true, onClick: T2 }, theirProps: n2, slot: m2, defaultTag: $e, name: "Dialog.Overlay" });
}
let je = "div";
function Je(t2, e2) {
  let r2 = I$4(), { id: i2 = `headlessui-dialog-backdrop-${r2}`, ...n2 } = t2, [{ dialogState: l2 }, s2] = b("Dialog.Backdrop"), a2 = y$1(e2);
  useEffect(() => {
    if (s2.panelRef.current === null)
      throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [s2.panelRef]);
  let T2 = useMemo(() => ({ open: l2 === 0 }), [l2]);
  return React__default.createElement(l$1, { force: true }, React__default.createElement(te, null, C({ ourProps: { ref: a2, id: i2, "aria-hidden": true }, theirProps: n2, slot: T2, defaultTag: je, name: "Dialog.Backdrop" })));
}
let Xe = "div";
function Ke(t2, e2) {
  let r2 = I$4(), { id: i2 = `headlessui-dialog-panel-${r2}`, ...n2 } = t2, [{ dialogState: l2 }, s2] = b("Dialog.Panel"), a2 = y$1(e2, s2.panelRef), T2 = useMemo(() => ({ open: l2 === 0 }), [l2]), m2 = o$4((f2) => {
    f2.stopPropagation();
  });
  return C({ ourProps: { ref: a2, id: i2, onClick: m2 }, theirProps: n2, slot: T2, defaultTag: Xe, name: "Dialog.Panel" });
}
let Ve = "h2";
function qe(t2, e2) {
  let r2 = I$4(), { id: i2 = `headlessui-dialog-title-${r2}`, ...n2 } = t2, [{ dialogState: l2, setTitleId: s2 }] = b("Dialog.Title"), a2 = y$1(e2);
  useEffect(() => (s2(i2), () => s2(null)), [i2, s2]);
  let T2 = useMemo(() => ({ open: l2 === 0 }), [l2]);
  return C({ ourProps: { ref: a2, id: i2 }, theirProps: n2, slot: T2, defaultTag: Ve, name: "Dialog.Title" });
}
let ze = U$1(We), Qe = U$1(Je), Ze = U$1(Ke), et = U$1(Ye), tt = U$1(qe), _t = Object.assign(ze, { Backdrop: Qe, Panel: Ze, Overlay: et, Title: tt, Description: G });
const MobileHeaderClose = "data:image/svg+xml;base64,PHN2ZwogICAgd2lkdGg9IjI0IgogICAgaGVpZ2h0PSIyMCIKICAgIHZpZXdCb3g9IjAgMCAyOSAyOCIKICAgIGZpbGw9Im5vbmUiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgPgogICAgPHBhdGgKICAgICAgZmlsbFJ1bGU9ImV2ZW5vZGQiCiAgICAgIGNsaXBSdWxlPSJldmVub2RkIgogICAgICBkPSJNMTYuODI4NSAxNC4wMDA1TDI3LjQxNDUgMy40MTQ1QzI4LjE5NjUgMi42MzI1IDI4LjE5NjUgMS4zNjg1IDI3LjQxNDUgMC41ODY1QzI2LjYzMjUgLTAuMTk1NSAyNS4zNjg1IC0wLjE5NTUgMjQuNTg2NSAwLjU4NjVMMTQuMDAwNSAxMS4xNzI1TDMuNDE0NSAwLjU4NjVDMi42MzI1IC0wLjE5NTUgMS4zNjg1IC0wLjE5NTUgMC41ODY1IDAuNTg2NUMtMC4xOTU1IDEuMzY4NSAtMC4xOTU1IDIuNjMyNSAwLjU4NjUgMy40MTQ1TDExLjE3MjUgMTQuMDAwNUwwLjU4NjUgMjQuNTg2NUMtMC4xOTU1IDI1LjM2ODUgLTAuMTk1NSAyNi42MzI1IDAuNTg2NSAyNy40MTQ1QzAuOTc2NSAyNy44MDQ1IDEuNDg4NSAyOC4wMDA1IDIuMDAwNSAyOC4wMDA1QzIuNTEyNSAyOC4wMDA1IDMuMDI0NSAyNy44MDQ1IDMuNDE0NSAyNy40MTQ1TDE0LjAwMDUgMTYuODI4NUwyNC41ODY1IDI3LjQxNDVDMjQuOTc2NSAyNy44MDQ1IDI1LjQ4ODUgMjguMDAwNSAyNi4wMDA1IDI4LjAwMDVDMjYuNTEyNSAyOC4wMDA1IDI3LjAyNDUgMjcuODA0NSAyNy40MTQ1IDI3LjQxNDVDMjguMTk2NSAyNi42MzI1IDI4LjE5NjUgMjUuMzY4NSAyNy40MTQ1IDI0LjU4NjVMMTYuODI4NSAxNC4wMDA1WiIKICAgICAgZmlsbD0id2hpdGUiCiAgICAvPgogIDwvc3ZnPg==";
const MobileHeaderOpen = "data:image/svg+xml;base64,PHN2ZwogIHdpZHRoPSIxNiIKICBoZWlnaHQ9IjEyIgogIHZpZXdCb3g9IjAgMCAxNiAxMiIKICBmaWxsPSJub25lIgogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKPgogIDxsaW5lIHgxPSIwIiB5MT0iMTEiIHgyPSIxNiIgeTI9IjExIiBzdHJva2U9IndoaXRlIiAvPgogIDxsaW5lIHgxPSIwIiB5MT0iNiIgeDI9IjE2IiB5Mj0iNiIgc3Ryb2tlPSJ3aGl0ZSIgLz4KICA8bGluZSB4MT0iMCIgeTE9IjEiIHgyPSIxNiIgeTI9IjEiIHN0cm9rZT0id2hpdGUiIC8+Cjwvc3ZnPg==";
const MobileSidebar = (props) => {
  useSidebarHandlers({ ...props });
  const { setOnMenuItemClick } = useSidebarStore();
  const [sidebarOpened, setSidebarOpened] = useState(false);
  useEffect(() => {
    const handleMenuItemClick = (title) => {
      if (props.onMenuItemClick) {
        props.onMenuItemClick(title);
      }
      closeSidebar();
    };
    setOnMenuItemClick(handleMenuItemClick);
  }, [props.onMenuItemClick, setOnMenuItemClick, setSidebarOpened]);
  const openMenuClickHandler = (event) => {
    event.stopPropagation();
    document.body.classList.add("overflow-hidden");
    setSidebarOpened(true);
  };
  const closeSidebar = () => {
    document.body.classList.remove("overflow-hidden");
    setSidebarOpened(false);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "button",
      {
        className: twMerge(
          "flex h-[42px] w-[42px] items-center justify-center rounded-md bg-black p-[8px]",
          props.mobileToggleButtonClassOverrides
        ),
        "aria-label": "Menu Toggle Button",
        onClick: openMenuClickHandler,
        children: /* @__PURE__ */ jsx("img", { src: MobileHeaderOpen, className: "m-[12px] h-full w-full" })
      }
    ),
    /* @__PURE__ */ jsx(_t, { open: sidebarOpened, onClose: closeSidebar, children: /* @__PURE__ */ jsx(_t.Panel, { children: /* @__PURE__ */ jsxs("div", { className: "fixed left-0 top-0 z-[1000] flex w-full flex-col justify-start bg-black h-screen", children: [
      /* @__PURE__ */ jsx("div", { className: "flex w-full items-center justify-end p-[16px]", children: /* @__PURE__ */ jsx(
        "button",
        {
          className: "flex h-[60px] w-[60px] items-center justify-center rounded-md p-[16px] hover:bg-white/10",
          onClick: (event) => {
            event.stopPropagation();
            closeSidebar();
          },
          children: /* @__PURE__ */ jsx("img", { src: MobileHeaderClose })
        }
      ) }),
      /* @__PURE__ */ jsx(SidebarMenu, { isMobile: true, children: props.children }),
      /* @__PURE__ */ jsx(SidebarFooter, { isMobile: true })
    ] }) }) })
  ] });
};
export {
  MenuItem,
  MenuItemExpandable,
  MobileSidebar,
  Sidebar
};
